// 内容取自希尔顿官网移动端会员权益页 https://www.hilton.com.cn/zh-cn/member-benefits
// 文案与官网一致；按项目要求去除所有第三方跳转链接

export const TIERS = [
  { key: "member", name: "会员会籍", color: "#003065", requirement: ["免费注册即可"] },
  { key: "silver", name: "银会籍", color: "#9B9B9B", requirement: ["10晚住宿或", "4次住宿或", "2,500美元消费"] },
  { key: "gold", name: "金会籍", color: "#B48947", requirement: ["25晚住宿或", "15次住宿或", "6,000美元消费"] },
  { key: "diamond", name: "钻石会籍", color: "#304451", requirement: ["50晚住宿或", "25次住宿或", "11,500美元消费"] },
  { key: "onyx", name: "曜钻会籍", color: "#000000", requirement: ["80晚住宿或", "40次住宿或", "18,000美元消费"] },
];

export const COMPARISON_TITLE = "会员权益对比";
export const CONDITION_HEADER = ["会籍等级条件:", "一个日历年内"];

export const COMPARISON_ROWS = [
  {"label": "尊贵会籍额外奖励¹", "values": [{"t": "x"}, {"t": "s", "v": "20%"}, {"t": "s", "v": "80%"}, {"t": "s", "v": "100%"}, {"t": "s", "v": "120%"}]},
  {"label": "积分兑换免费房晚及更多礼遇", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "会员专属最优房价", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "奖励住宿无日期限制", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "享用屡获大奖的希尔顿荣誉客会App", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}], "desc": "电子入住/退房、电子房卡共享、在线选房²"},
  {"label": "免费无线上网", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "s", "v": "高速无线上网"}, {"t": "s", "v": "高速无线上网"}]},
  {"label": "尊享千载难逢的专属体验", "values": [{"t": "y", "tier": "member"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "免费瓶装水²", "values": [{"t": "x"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "奖励住宿第5晚免费", "values": [{"t": "x"}, {"t": "y", "tier": "silver"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "客房升级(可提供时)，入住前三天确认²", "values": [{"t": "x"}, {"t": "x"}, {"t": "y", "tier": "gold"}, {"t": "s", "v": "优先升房"}, {"t": "s", "v": "最高优先升房"}]},
  {"label": "免费早餐或酒店内餐饮消费抵扣²", "values": [{"t": "x"}, {"t": "x"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "里程碑奖励", "values": [{"t": "x"}, {"t": "x"}, {"t": "y", "tier": "gold"}, {"t": "y", "tier": "diamond"}, {"t": "d"}], "desc": "每年最高可累积 180 晚或 21 万点积分"},
  {"label": "行政酒廊使用券²", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "y", "tier": "diamond"}, {"t": "d"}], "desc": "*视房态可升级至行政房"},
  {"label": "48小时客房保证²", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "y", "tier": "diamond"}, {"t": "d"}]},
  {"label": "礼赠尊贵会籍", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "y", "tier": "diamond"}, {"t": "d"}], "desc": "会员年入住满 60 晚可赠送金会籍，满 100 晚可赠送钻石会籍"},
  {"label": "高级俱乐部使用权³", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "d"}], "badge": "全新！"},
  {"label": "客房升级确认奖励⁴", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "d"}], "badge": "全新！", "desc": "预订时即可确认房型升级"},
  {"label": "下午 4 点延迟退房保障", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "d"}], "badge": "全新！"},
  {"label": "曜钻会籍专属客服", "values": [{"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "x"}, {"t": "d"}], "badge": "全新！"},
];

export const TIER_SECTIONS = [
  {
    key: "member", name: "会员会籍",
    title: "会员会籍礼遇",
    requirements: "免费注册即可成为会员",
    intro: "会员会籍 尊享礼遇:",
    benefits: [
      { title: "希尔顿荣誉客会保证折扣价格", desc: "当您通过 Hilton.com 或我们的应用程序上预订时, 可以希尔顿荣誉客会会员的身份享受专属房价。*" },
      { title: "可用于免费住宿和可在旅行合作伙伴使用的积分及其他福利", desc: "每次住宿均可赚取积分。将积分转换成免费住宿, 在我们的专属旅行合作伙伴使用积分,享受体验及更多礼遇。" },
      { title: "奖励住宿无需支付度假村费", desc: "您已赚取奖励住宿。使用全部积分即可享受奖励住宿,且无需支付任何隐藏的费用。" },
      { title: "在线选房", desc: "使用希尔顿荣誉客会应用程序,可在任何地方办理入住手续。" },
      { title: "数字退房", desc: "使用希尔顿荣誉客会应用程序，可在任何地方办理退房手续。" },
      { title: "选择客房", desc: "可提前24小时选择可用客房。" },
      { title: "电子房卡", desc: "使用您的设备和希尔顿荣誉客会应用程序开门。" },
      { title: "免费无线上网*", desc: "充分利用整个酒店的免费无线网络*。" },
      { title: "可获得专属的希尔顿荣誉客会体验", desc: "以千载难逢的体验犒赏自己。在拍卖会上标中专属套餐或用积分兑换不可思议的物品。" },
      { title: "延迟退房（可提供时）", desc: "有点贪睡？致电前台申请延迟退房。" },
    ],
  },
  {
    key: "silver", name: "银会籍",
    title: "银会籍礼遇",
    requirements: "10晚住宿或4次住宿或2,500美元消费",
    intro: "除了 会员会籍 外,您还将享有:",
    benefits: [
      { title: "住宿可赚取20%的奖励积分", desc: "更快赚取免费住宿,并可在每次住宿赚取的基本积分基础上获得20%的奖励积分。" },
      { title: "免费瓶装水", desc: "抵达(指定酒店)时免费获赠两瓶水。" },
      { title: "奖励住宿第5晚免费", desc: "您已赚取奖励住宿。使用全部积分即可享受奖励住宿,且无需支付任何隐藏的费用。" },
      { title: "全包式水疗折扣", desc: "希尔顿品牌组合旗下的全包式水疗中心享受八五折优惠。" },
    ],
  },
  {
    key: "gold", name: "金会籍",
    title: "金会籍礼遇",
    requirements: "25晚住宿或15次住宿或6,000美元消費",
    intro: "除了 会员会籍 和 银会籍 礼遇外,您还将享有:",
    benefits: [
      { title: "住宿可赚取80%的奖励积分", desc: "更快赚取免费住宿,并可在每次住宿赚取的基本积分基础上获得80%的奖励积分。" },
      { title: "根据房态免费升房", desc: "如果我们有更好的客房可供使用,则为您提供——至高可提供高级层客房。" },
      { title: "每日餐饮积分或欧陆式早餐 (因品牌和地区而异)", desc: "您的“我的方式”礼遇包括，于美国境内指定品牌和全球希尔顿摩庭酒店获得每日餐饮积分，以及美国境外指定品牌（不包括希尔顿摩庭）的免费欧陆式早餐。酒店将为您提供积分或欧陆式早餐。住宿期间，您每晚可在同一间客房登记最多一位额外宾客。钻石和金卡会员在行政酒廊享用供早餐时，将无法获得每日餐饮积分。" },
      { title: "里程碑奖励", desc: "在一个日历年内入住满40晚后,每住宿10晚可赚取10,000点奖励积分。" },
    ],
  },
  {
    key: "diamond", name: "钻石会籍",
    title: "钻石会籍礼遇",
    requirements: "50晚住宿或25次住宿或11,500美元消费",
    intro: "除了 会员会籍 、 银会籍 和 金会籍 礼遇外,您还将享有:",
    benefits: [
      { title: "住宿可赚取100%的奖励积分", desc: "在您每次住宿所赚取的所有基本积分基础上获得全部奖励积分。" },
      { title: "根据房态免费升房", desc: "如果我们有更好的客房可供使用,则为您提供————— 至高可提供单卧室套房。" },
      { title: "可使用行政酒廊", desc: "无论专注或放松,或两者兼而有之,在我们静谧的休憩之所您可以享受专属便利设施。" },
      { title: "钻石会籍延期", desc: "享受额外一年的钻石会籍礼遇和一次会籍延期。在您成为钻石会员3年且终生住宿时间满250晚或赚取500,000点基本积分后可享受此福利。" },
      { title: "高速无线上网", desc: "将您的无线网络升级到酒店中速度至快的无线网络——卓越的速度。" },
      { title: "48 小时客房保证", desc: "在重要行程中，即使酒店已客满，仍需要这间客房——请放心，如果您在入住前至少48小时联系，则可以预订此客房，但需遵守适用的限制条件。" },
      { title: "礼赠尊贵会籍", desc: "如果您在一个日历年中住满60晚，您可以向任何会员赠送金会籍资格。如果您入住100晚，则可赠送钻石会籍。" },
    ],
  },
  {
    key: "onyx", name: "曜钻会籍",
    title: "曜钻会籍礼遇",
    requirements: "80晚或40次住宿,以及18,000美元的年度认可消费",
    intro: "除了 会员会籍 、 银会籍 、 金会籍 和 钻石会籍 礼遇外,您还将享有:",
    benefits: [
      { title: "住宿可赚取120%的奖励积分", desc: "在您每次住宿所赚取的所有基本积分基础上获得120%奖励积分。" },
      { title: "下午4:00 点延迟退房 保证", desc: "下午4:00 保证延迟退房" },
      { title: "客房升级确认奖励", desc: "选择并确认尊享客房升级,最高可升级至套房, 预订时间即可确认,最多7晚住宿可享" },
      { title: "曜钻会籍专属服务", desc: "全新升级的客户服务体验 -更j快捷地获享我们优质客服人员的帮助" },
      { title: "高级俱乐部使用权", desc: "免费使用所有酒廊，包括我们不断扩展的尊贵俱乐部系列。" },
    ],
  },
];

// 表格下方备注。terms 一项官网为跳转 hilton.com 的链接，按要求改为纯文本
export const FOOTNOTES = [
  {"type": "p", "text": "*所有酒店内权益需通过官方渠道预订并确认，官方渠道包括希尔顿官网、希尔顿预订与客户服务电话、希尔顿荣誉客会 App，或希尔顿荣誉客会条款与细则中定义的其他渠道。"},
  {"type": "p", "text": "1. 所示积分赚取比率是基于基本积分的额外奖励积分。"},
  {"type": "p", "text": "2. 适用于指定品牌和 / 或酒店。", "noMargin": true},
  {"type": "ul", "items": ["或有其他限制和例外情况，并非所有酒店都提供所有礼遇。", "以下品牌不提供免费升级：希尔顿花园、希尔顿欢朋及希尔顿惠庭酒店。", "希尔顿荣誉客会会籍、包括赚取和兑换积分，享受酒店礼遇、设施与服务，需遵守希尔顿荣誉客会条款和细则。如需查看完整适用条款，请访问 www.hilton.com/zh-hans/hilton-honors/terms。"]}
];
